import {
    useCallback,
} from 'react'
import {
    useQueryClient,
} from '@tanstack/react-query'

import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'
import {
    Position,
    Position as PositionType,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import {
    RichTableData,
} from 'app/types/richtable.types'

import requests from 'app/requests/Order/OrderBilling.requests'

const useGetPositionsByInvoiceId = (invoiceId) => {
    const queryClient = useQueryClient()
    const refresh = () => {
        queryClient.invalidateQueries({
            queryKey: [RequestKeys.getPositionsByInvoiceId],
        })
    }

    const {
        data,
    } = useRequestTable<RichTableData<PositionType[]>>({
        key: RequestKeys.getPositionsByInvoiceId,
        params: {
            outgoingInvoiceId: invoiceId,
        },
        config: requests.filterAllPositions,
        enabled: Boolean(invoiceId),
    })

    const load = useCallback((): Promise<RichTableData<Position[]>> => {
        if (!data) {
            return Promise.resolve({
                data: [],
            })
        }
        return Promise.resolve(data)
    }, [data])

    return {
        refresh,
        load,
    }
}

export default useGetPositionsByInvoiceId
